export default "__VITE_ASSET__KiPDghkV__"